import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { CompanyDTO, CompetencyCondition, CompetencyDTO, CompetencyService, EmployeeDTO } from "src/shared/api/generated";
import { EmployeeCompetencyLevelService } from "src/shared/services/employee-competency-level.service";
import { SideToolbarService } from "src/shared/services/side-toolbar.service";

@Component({
  selector: "app-search-sidebar",
  templateUrl: "./search-sidebar.component.html",
  styleUrls: ["./search-sidebar.component.scss"],
})
export class SearchSidebarComponent implements OnInit {
  @Output() search = new EventEmitter<CompetencyCondition[]>();
  @Output() companySelectionChanged = new EventEmitter<CompanyDTO[]>();
  @Output() senioritySelectionChanged = new EventEmitter<EmployeeDTO.SeniorityEnum[]>();
  private competencies: CompetencyDTO[] = [];
  filteredCompetencies: CompetencyDTO[] = [];
  competencyInputs: CompetencyCondition[] = [];
  private competencyConditions: CompetencyCondition[] = [];

  constructor(private competencyService: CompetencyService, private sideToolbarService: SideToolbarService,
    private employeeCompetencyLevelService: EmployeeCompetencyLevelService
  ) {}

  ngOnInit() {
    this.sideToolbarService.openSideToolbar();
    this.fetchCompetencies().subscribe((allCompetencies) => {
      this.sideToolbarService.openSideToolbar();
      this.competencies = allCompetencies;
      this.filterCompetencies();
    });
  }

  private fetchCompetencies() {
    return this.competencyService.getAllCompetencies();
  }

  onCompanySelectionChanged(companies: CompanyDTO[]) {
    this.companySelectionChanged.emit(companies);
  }

  onSenioritySelectionChanged(seniorities: EmployeeDTO.SeniorityEnum[]) {
    this.senioritySelectionChanged.emit(seniorities);
  }

  filterCompetencies() {
    this.filteredCompetencies = this.competencies
      .filter((competency) => {
        return !this.competencyConditions
          .map((input) => input.competencyId)
          .includes(competency.id!);
      }).sort((a,b) => a.name.localeCompare(b.name));
  }

  addNewCompetencyInput() {
    this.competencyInputs.push({
      competencyId: -1,
      lowerBound: this.employeeCompetencyLevelService.getDefaultOption(),
      upperBound: this.employeeCompetencyLevelService.getMaxOption(),
    });
    this.competencyConditions.push({
      competencyId: -1,
      lowerBound: this.employeeCompetencyLevelService.getDefaultOption(),
      upperBound: this.employeeCompetencyLevelService.getMaxOption(),
    });
  }

  removeCompetencyInput(index: number) {
    this.competencyInputs.splice(index, 1);
    this.competencyConditions.splice(index, 1);
    this.filterCompetencies();
  }

  updateCompetencyAt(condition: CompetencyCondition, index: number) {
    this.competencyConditions[index] = condition;
    this.filterCompetencies();
  }

  isSearchButtonDisabled() {
    if (this.competencyConditions.length === 0) {
      return true;
    }
    return (
      this.competencyConditions.filter((condition) => {
        return (
          condition.competencyId < 0 ||
          this.employeeCompetencyLevelService.getCompetencyLevel(condition.lowerBound) < 1 ||
          this.employeeCompetencyLevelService.getCompetencyLevel(condition.upperBound) > 4 ||
          this.employeeCompetencyLevelService.getCompetencyLevel(condition.lowerBound) > 
          this.employeeCompetencyLevelService.getCompetencyLevel(condition.upperBound)
        );
      }).length > 0
    );
  }

  searchWithConditions() {
    if (this.isSearchButtonDisabled()) return;
    this.search.emit(this.competencyConditions);
  }

  clearAllCompetencyConditions() {
    this.competencyInputs = [];
    this.competencyConditions = [];
    this.filterCompetencies();
  }
}
